import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { GA_MEASUREMENT_ID } from '../lib/analytics';

export function Analytics() {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];

    if (!window.gtag) {
      window.gtag = (...args: unknown[]) => {
        window.dataLayer?.push(args);
      };
    }

    let cancelled = false;

    const configureAnalytics = () => {
      if (cancelled) return;
      window.gtag?.('js', new Date());
      window.gtag?.('config', GA_MEASUREMENT_ID, { send_page_view: false });
    };

    const injectScript = () => {
      if (document.querySelector(`script[data-ga4="${GA_MEASUREMENT_ID}"]`)) {
        configureAnalytics();
        return;
      }

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      script.dataset.ga4 = GA_MEASUREMENT_ID;
      script.onload = configureAnalytics;
      document.head.appendChild(script);
    };

    if ('requestIdleCallback' in window) {
      const idleId = window.requestIdleCallback(injectScript, { timeout: 2000 });
      return () => {
        cancelled = true;
        window.cancelIdleCallback?.(idleId);
      };
    }

    const timeoutId = globalThis.setTimeout(injectScript, 1200);
    return () => {
      cancelled = true;
      globalThis.clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    if (!window.gtag) return;

    const pagePath = `${location.pathname}${location.search}${location.hash}`;
    window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: pagePath,
      send_to: GA_MEASUREMENT_ID,
    });
  }, [location]);

  return null;
}
